module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/purebarre-e0b3cc71cb679795836004bd8a4b697f.png";